export function initJPush() {
  return () => {}
}

export function syncJPushAlias(_userId?: number | null) {}

export async function getJPushRegistrationId() {
  return ""
}
